import React, { useState } from 'react';
import './DownloadMobileAppBanner.less';
import { ic_banner_close as CloseIcon } from 'app/widgets/SVGs';
import appIcon62 from '../../../../assets/images/ic_app.png';
import { useTranslation } from 'react-i18next';
import useUserOS from 'app/hooks/useUserOS';
import { useIsMobile } from 'app/hooks/useIsMobile';
import { useFirstVisitContext } from 'context/useFirstVisitContext';
import { downloadMobileAppBannerConfig } from 'app/components/banners/DownloadMobileAppBanner/downloadMobileAppBannerConfig';
import { useLocation } from 'react-router-dom';
import { BaseButton } from 'app/components/buttons/BaseButton';

// In case if we have more top banners a Banner Manager can be implemented.
// Due to <React.StrictMode> it won't be visible with NODE_ENV development
export default function DownloadMobileAppBanner() {
  const { t } = useTranslation();
  const location = useLocation();

  const isMobileWidth = useIsMobile();
  const os = useUserOS();
  const isMobileOS = os !== 'Other';

  const { isFirstVisit } = useFirstVisitContext();
  const [open, setOpen] = useState(true);

  const { pagesToShow } = downloadMobileAppBannerConfig;

  const isPageMatched = pagesToShow.some(path => {
    if (typeof path === 'string') {
      return location.pathname === path;
    }
    if (path instanceof RegExp) {
      return path.test(location.pathname);
    }
    return false;
  });

  // TODO move it to the env file?
  const appLink =
    os === 'Android'
      ? 'https://play.google.com/store/apps/details?id=com.kubotausa.mykubota'
      : 'https://apps.apple.com/us/app/mykubota/id1434354490';

  function handleClose() {
    setOpen(false);
  }

  const isBannerHidden =
    !open || !isFirstVisit || !isMobileWidth || !isMobileOS || !isPageMatched;

  if (isBannerHidden) {
    return null;
  }

  return (
    <div className="download-mobile-app-banner">
      <BaseButton onClick={handleClose}>
        <CloseIcon />
      </BaseButton>

      <img
        className="download-mobile-app-banner__icon"
        src={appIcon62}
        alt="App Logo"
      />

      <div className="download-mobile-app-banner__text">
        <span className="download-mobile-app-banner__title">
          {t('app_name')}
        </span>
        <span className="download-mobile-app-banner__subtitle">
          {t('download_app')}
        </span>
      </div>

      <BaseButton
        className="download-mobile-app-banner__button"
        onClick={() => {
          handleClose();
          window.open(appLink, '_blank', 'noopener,noreferrer');
        }}
      >
        {t('download')}
      </BaseButton>
    </div>
  );
}
